<template>
  <ElContainer class="content-layout">
    <ElMenu
      class="menu-list"
      :default-active="selectMenus"
      :unique-opened="true"
      :collapse="isCollapse"
      @select="handleselect"
    >
      <ElScrollbar class="menu-scrollbar">
        <ElMenuItem index="/home/person-center" class="menu_max_width">
          <!-- <SvgIcon name="logo" :size="26" color="#fff" /> -->
          <template #title>
            <div class="logo">
              <img class="logo_title" src="@/assets/images/logo.png" />
              <p>冠忠巴士集團成員</p>
            </div>
          </template>
        </ElMenuItem>
        <template v-for="item in menuList" :key="item.path">
          <ElSubMenu
            :index="item.path"
            :class="{
              hideIcon: isCollapse,
              isLine: isCollapse && route.path.includes(item.path),
            }"
          >
            <template #title>
              <SvgIcon :name="item.meta.icon" :size="16" color="#fff" />
              <span v-show="!isCollapse" style="margin-left: 4px">
                {{ item.meta.title }}
                <!-- 最外层 -->
              </span>
            </template>

            <template
              v-for="(v,i) in item.children.filter((a: any) => !a.meta.hidden)"
              :key="v.path + i"
            >
              <ElSubMenu :index="v.path" v-if="v.children?.length > 0">
                <template #title>
                  {{ v.meta.title }}
                  <!-- 二级子项并且拥有三级子项 -->
                </template>
                <span
                  v-for="vv in v.children.filter((a: any) => !a.meta.hidden)"
                  :key="vv.path"
                >
                  <a
                    v-if="vv.meta.target === '_blank'"
                    :index="vv.path"
                    :href="'/' + vv.path"
                  >
                    <ElMenuItem :key="vv.path">
                      {{ vv.meta.title }}
                      <!-- 三级子项 -->
                    </ElMenuItem>
                  </a>
                  <a
                    v-else
                    @click.prevent
                    @dragstart.prevent
                    :index="vv.path"
                    :href="item.path + '/' + v.path + '/' + vv.path"
                  >
                    <ElMenuItem :index="vv.path" :key="vv.path">
                      {{ vv.meta.title }}
                      <!-- 三级子项 -->
                    </ElMenuItem>
                  </a>
                </span>
              </ElSubMenu>
              <a
                v-else-if="v.meta.target === '_blank'"
                :href="'/' + v.path"
                target="_blank"
              >
                <ElMenuItem>
                  {{ v.meta.title }}
                  <!-- 二级子项 -->
                </ElMenuItem>
              </a>
              <a
                v-else
                :href="item.path + '/' + v.path"
                @click.prevent
                @dragstart.prevent
              >
                <ElMenuItem :index="v.path">
                  {{ v.meta.title }}
                  <!-- 二级子项 -->
                </ElMenuItem>
              </a>
            </template>
          </ElSubMenu>
        </template>
      </ElScrollbar>
      <div class="menu-collapse">
        <ElButton @click="handleCollapse" type="primary">
          <SvgIcon name="expand" :size="24" color="#fff" />
        </ElButton>
      </div>
    </ElMenu>
    <ElContainer class="layout-container">
      <ElHeader class="layout-header">
        <div class="flex header">
          <ElBreadcrumb separator="/">
            <ElBreadcrumbItem>首页</ElBreadcrumbItem>
            <ElBreadcrumbItem
              v-for="(item, index) in breadcrumbList"
              :key="item.path"
            >
              <a :class="{ isActive: index === breadcrumbList.length - 1 }">
                {{ item.title }}
              </a>
            </ElBreadcrumbItem>
          </ElBreadcrumb>

          <div class="flex">
            <!-- 功能按钮组 -->
            <div class="function-buttons">
              <PosManager />
              <ElButton
                class="complex_btn"
                @click="openDialogTable"
                :loading="openLoading"
              >
                异常单
              </ElButton>
              <ElButton
                class="yushen_btn"
                v-show="yushen_settlement_dayreve_btn"
                @click="addYushen"
              >
                今日营收
              </ElButton>
            </div>

            <!-- 币种选择组 -->
            <div class="currency-section">
              <el-radio-group
                v-model="userInfo.currencyType"
                class="currency-items"
              >
                <el-radio-button
                  v-for="currencyItem in userInfo.currencyTypeList"
                  :key="currencyItem"
                  :value="currencyItem"
                  @click.prevent="handleSwitchCurrency(currencyItem)"
                >
                  {{ enumeration_currencyTypeName[currencyItem] }}
                </el-radio-button>
              </el-radio-group>
            </div>

            <div class="currency_unit">
              {{ userInfo.unitName }}
            </div>

            <el-dropdown placement="bottom-end" @command="handleGo">
              <ElButton class="flex person">
                <SvgIcon name="avatar" :size="24" />
                <span class="title-avatar">{{ userInfo.name }}</span>
              </ElButton>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item command="a" class="person_dropdown_item">
                    个人中心
                  </el-dropdown-item>
                  <el-dropdown-item command="b" class="person_dropdown_item">
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </ElHeader>
      <ElMain class="layout-main">
        <section class="main-container">
          <router-view v-slot="{ Component }">
            <template v-if="Component">
              <keep-alive :include="includeComponent">
                <component :is="Component" :key="$route.path" />
              </keep-alive>
            </template>
          </router-view>
        </section>
      </ElMain>
    </ElContainer>
  </ElContainer>
  <ElDialog
    v-model="dialogVisible"
    title="退出确认"
    width="30%"
    :show-close="false"
  >
    <div class="tips-m">退出后需重新登录，请确认是否退出当前登录</div>
    <template #footer>
      <span class="dialog-footer">
        <ElButton @click="dialogVisible = false">取消</ElButton>
        <ElButton type="primary" @click="confirm">确定</ElButton>
      </span>
    </template>
  </ElDialog>

  <ElDialog
    v-model="dialogSwitchCurrencyVisible"
    title="确认切换币种"
    width="30%"
    :show-close="false"
  >
    <div class="tips-m">切换币种将刷新页面、清除购物车车票。</div>
    <template #footer>
      <span class="dialog-footer">
        <ElButton @click="dialogSwitchCurrencyVisible = false">取消</ElButton>
        <ElButton type="primary" @click="confirmSwitchCurrency">
          确定
        </ElButton>
      </span>
    </template>
  </ElDialog>
  <ElDialog
    v-model="dialogTableVisible"
    title="异常单"
    width="80%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <div>
      <ElTable
        :data="diffTableData"
        border
        style="width: 100%"
        class="diffTableClass"
        v-loading="frechLoading"
        scrollbar-always-on
        height="600"
        highlight-current-row
      >
        <ElTableColumn type="index" width="40">
          <template #default="scope">
            <div class="table-number">
              {{ scope.$index + 1 }}
            </div>
          </template>
        </ElTableColumn>
        <ElTableColumn prop="orderNo" label="订单号" width="200" />
        <ElTableColumn prop="ticketNos" label="车票号" min-width="120">
          <template #default="scope">
            <div
              v-if="scope.row.ticketNos && scope.row.ticketNos.length > 0"
              class="ticket-flex-container"
            >
              {{ scope.row.ticketNos.join("、") }}
            </div>
            <span v-else>-</span>
          </template>
        </ElTableColumn>
        <ElTableColumn prop="orderTypeName" label="订单类型" width="120">
        </ElTableColumn>
        <ElTableColumn prop="payTypeName" label="支付方式" width="100" />
        <ElTableColumn prop="amount" label="金额" width="110">
          <template #default="scope">
            {{ enumeration_currencyType[scope.row.currencyType] }}
            {{ scope.row.amount }}
          </template>
        </ElTableColumn>
        <ElTableColumn prop="abnormalDesc" label="异常情况" width="80">
          <template #default="scope">
            <span
              :class="{
                'unpaid-text': scope.row.abnormalType === 1,
                'unprinted-row': scope.row.abnormalType === 2,
              }"
            >
              {{ scope.row.abnormalDesc }}
            </span>
          </template>
        </ElTableColumn>
        <ElTableColumn prop="createTime" label="下单时间" width="80">
          <template #default="scope">
            {{
              scope.row.createTime
                ? dayjs(scope.row.createTime).format("HH:mm:ss")
                : ""
            }}
          </template>
        </ElTableColumn>
        <ElTableColumn label="操作" width="110">
          <template #default="scope">
            <ElButton
              text
              class="select_btn"
              type="primary"
              @click.prevent="handleJumpQuery(scope.row)"
            >
              详情
            </ElButton>
            <ElButton
              v-show="scope.row.abnormalType === 1"
              text
              class="select_btn"
              type="danger"
              @click.prevent="handleCancelOrder(scope.row)"
            >
              取消
            </ElButton>
          </template>
        </ElTableColumn>
      </ElTable>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <ElButton type="success" @click="handlereFreshTable"> 刷新 </ElButton>
        <ElButton type="danger" @click="dialogTableVisible = false">
          关闭
        </ElButton>
      </span>
    </template>
  </ElDialog>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, nextTick, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  ElContainer,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElButton,
  ElScrollbar,
  ElHeader,
  ElBreadcrumb,
  ElBreadcrumbItem,
  ElMain,
  ElDialog,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElRadioGroup,
  ElRadioButton,
  ElNotification,
  ElTable,
  ElTableColumn,
  ElMessage,
} from "element-plus";
import axios, { ResponseType } from "@/utils/request";
import SvgIcon from "@/components/SvgIcon.vue";
import {
  enumeration_currencyTypeName,
  enumeration_currencyType,
  enumeration_order_type,
} from "@/utils/enumerations";
import usePiniaStore from "@/store/index";
import {
  Http_postUserSwitchCurrency,
  Http_getOrderAbnormal,
  Http_postOrderAbnormalCancel,
} from "@/http/apiFunction";
import type { AbnormalOrderInfo } from "@/http/response.type";
import { usePermissions } from "@/hooks/usePermissions";
import dayjs from "dayjs";
import PosManager from "@/components/PosManager.vue";

const { cityListStore, userStore, paymentStore, fyPosStore } = usePiniaStore();
const router = useRouter();
const route = useRoute();
const isCollapse = ref(false);
const dialogVisible = ref(false);
const dialogSwitchCurrencyVisible = ref(false);
const chooseCurrencyType = ref(1);

const userInfo = computed(() => userStore.personInfo);
const selectMenus = computed(() => userStore.selectMenus);
const menuList: any = computed(() => userStore.menus);
const breadcrumbList = computed(() => userStore.breadcrumbList);
const includeComponent = computed(() => userStore.includeComponent);
const msgIdList: any = ref([]);
// 今日营收-权限
const yushen_settlement_dayreve_btn = usePermissions(
  "yushen_settlement_dayreve_btn"
);

const dialogTableVisible = ref(false);
const diffTableData = ref<AbnormalOrderInfo[]>([
  {
    orderId: 0,
    orderNo: "12312312",
    ticketNoLists: [""],
    amount: 0,
    currencyType: 0,
    abnormalType: 0, // 1未支付，2未打印
    abnormalDesc: "",
    createTime: "",
    type: 0,
    status: 0,
    createBy: "",
    printed: 0,
  },
]);
const frechLoading = ref(false);
const openLoading = ref(false);
// 保存BroadcastChannel实例的引用，用于清理
let broadcastChannel = ref<BroadcastChannel | null>(null);

onMounted(() => {
  const defaultV = route.meta.from as string;
  userStore.updateSelectMenus(defaultV); // 手动刷新页面，更新菜单命中
  userStore.getMyRole(); // 获取用户的权限和初始化菜单栏
  userStore.getPersonInfo(); // 更新用户信息
  cityListStore.getCityList(); // 更新城市信息

  // 初始化支付方式数据，只在应用启动时获取一次
  paymentStore.getPaymentOptions(true);
  // 初始化会话ID，确保缓存验证机制正常工作
  paymentStore.initializeSession();

  queryInnerMessage();

  // 使用 nextTick 确保组件完全挂载后再设置监听器
  nextTick(() => {
    // 增加额外延迟，确保所有同步代码执行完毕
    setupBroadcastListener();
  });
});

onUnmounted(() => {
  // 组件销毁时清理BroadcastChannel
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }
});

/**
 * 设置 BroadcastChannel 监听器
 * 使用延迟处理机制确保消息有序性，避免与页面初始化产生竞态条件
 */
const setupBroadcastListener = () => {
  const senderTabId = sessionStorage.getItem("senderTabId");
  console.log("🚀 结束:", senderTabId);

  // 如果已存在channel实例，先清理
  if (broadcastChannel.value) {
    broadcastChannel.value.close();
    broadcastChannel.value = null;
  }

  broadcastChannel.value = new BroadcastChannel("reload_control");
  broadcastChannel.value.addEventListener("message", (event) => {
    if (event.data.type === "RELOAD_OTHER_TABS") {
      // 如果不是发送者，则处理reload指令
      if (event.data.senderTabId !== senderTabId) {
        // 是否关闭确认离开提示
        sessionStorage.setItem("window_leave_confirm_closed", "true");
        location.reload();
      }
    }
  });
};

interface messageType {
  id: number;
  title: string;
  content: string;
  readStatus: number; //读状态：1-已读，0-未读
}
const queryInnerMessage = async () => {
  const res: ResponseType = await axios.get("/facade/sale/sitemsg/user/page");
  if (res.code === 0) {
    let message = "";
    res.data?.list.forEach((item: messageType) => {
      if (item.readStatus === 0 && msgIdList.value.length < 10) {
        message += `<p>${item.title}</p>`;
        msgIdList.value.push(item.id);
      }
    });
    if (msgIdList.value.length > 0) {
      ElNotification({
        title: "未读站内通知",
        message: message,
        dangerouslyUseHTMLString: true,
        position: "bottom-right",
        duration: 0,
        onClose: closeNotices,
        onClick: goToPersonCenter,
      });
    }
  }
};

// 关闭站内通知弹窗-标记站内通知为已读
const closeNotices = async () => {
  const res: ResponseType = await axios.post("/facade/sale/sitemsg/user/read", {
    idList: msgIdList.value,
  });
  if (res.code === 0) {
    console.log("站内通知已读");
  }
};

const goToPersonCenter = () => {
  router.push("/home/person-center");
};

const handleCollapse = () => {
  isCollapse.value = !isCollapse.value;
};

const handleselect = (key: string, keyPath: string[]) => {
  if (key === "/") return;

  const path = keyPath.join("/");
  // 打开查询+表单页面的刷新
  cityListStore.updateNeedReflash(true);
  // 点击同一个菜单
  if (router.currentRoute.value.path === path) {
    cityListStore.updateReflashNum();
  } else {
    router.push(path);
  }
};

const handleGo = (val: string) => {
  if (val === "a") {
    router.push("/home/person-center");
  } else {
    dialogVisible.value = true;
  }
};

// const newtab = (e, v) => {
//   console.log("gaoxiao ", e);
//   console.log("xixihaha ", v);
//   const { path } = v;
//   e.target.innerHTML = `<a href=${path}>${v.meta.title}</a>`;
// };

const confirmSwitchCurrency = async () => {
  const res = await Http_postUserSwitchCurrency(chooseCurrencyType.value);
  if (res.code === 0) {
    localStorage.setItem("token_value", res.data.token);
    window.location.reload();
  }
};
const handleSwitchCurrency = async (val: number) => {
  if (
    userInfo.value.currencyTypeList &&
    userInfo.value.currencyTypeList.length === 1
  ) {
    return;
  }
  chooseCurrencyType.value = val;
  dialogSwitchCurrencyVisible.value = true;
};
const confirm = async () => {
  const res: ResponseType = await axios.post("/facade/sale/login/out");
  if (res.code === 0) {
    router.replace(`/login`); // 主动退出
    sessionStorage.setItem("redirectUrl", ""); // 主动退出不记历史地址。
    localStorage.setItem("token_value", "");
    userStore.updateBreadcrumbList([]); // 主动退出清空面包屑
  }
};

const addYushen = () => {
  router.push({
    path: "/settlement-management/add-yushen",
  });
};

const handleJumpQuery = (row: AbnormalOrderInfo) => {
  // 跳转订单详情
  console.log("打印", row);
  let url = "";

  if (row.type > 100) {
    // 旅游产品
    url = "/tour-product/API-product-order-detail";
  } else if (row.type === 12 || row.type === 25) {
    // 包车票
    url = "/order-tickets-management/ticket-charter-detail";
  } else {
    // 其他为车票
    url = "/order-tickets-management/order-list-store-detail";
  }
  dialogTableVisible.value = false;

  router.push({
    path: url,
    query: {
      id: row.orderId,
    },
  });
};

const handleCancelOrder = async (row: any) => {
  frechLoading.value = true;
  const parmas = {
    orderId: row.orderId,
  };
  const res = await Http_postOrderAbnormalCancel(parmas);
  frechLoading.value = false;

  if (res.code === 0) {
    ElMessage.success("取消成功");
  }
  handlereFreshTable();
};

const openDialogTable = async () => {
  // 包车票订单不显示
  openLoading.value = true;
  const res = await Http_getOrderAbnormal();
  openLoading.value = false;

  if (res.code === 0) {
    diffTableData.value = res.data;
    dialogTableVisible.value = true;
  }
};

const handlereFreshTable = async () => {
  // 刷新表格
  frechLoading.value = true;
  const res = await Http_getOrderAbnormal();
  frechLoading.value = false;

  if (res.code === 0) {
    diffTableData.value = res.data;
  }
};
</script>

<style lang="scss" scoped>
.content-layout {
  height: 100%;
  width: 100%;
}

.menu-list {
  display: flex;
  flex-direction: column;
}

.menu-title {
  height: 48px;
  font-weight: 500;
  font-size: 15px;
  line-height: 48px;
  padding: 0 28px;
}
.menu-scrollbar {
  flex: 1;
  width: 180px; // 固定宽度，与全局样式保持一致，防止宽度抖动
  overflow-x: hidden;
  transition: width 0.02s ease; // 添加平滑过渡
}

// 折叠状态下的滚动容器固定宽度
.menu-list.el-menu--collapse .menu-scrollbar {
  width: 64px;
}
.logo {
  width: 100%;
  height: 76px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  p {
    line-height: 14px;
    font-size: 10px;
  }
}
.logo_title {
  width: 84px;
  height: 42px;
}
.menu-collapse {
  padding: 0 7px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 15px;
  color: #fff;
}
.layout-container {
  min-width: 1250px;
}
.layout-header {
  height: 48px;
  background: #f8f9fa;
  border-bottom: 1px solid #eaecf1;
  box-shadow: 0px 1px 4px rgba(0, 21, 41, 0.12);
}
.header {
  height: 48px;
}
.person {
  border: none;
}

.layout-main {
  height: 100%;
  padding: 12px;
  padding-bottom: 0px;
  background-color: #f8f9fa; /* 与body背景色一致，更护眼 */
}
.main-container {
  height: 100%;
  border-radius: 4px;
  background-color: #f8f9fa;
  overflow: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3); /* 添加轻微阴影提升层次感 */
}
// ::-webkit-scrollbar {
//   height: 0;
//   width: 0;
//   color: transparent;
// } // 取消隐藏
.title-avatar {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
  text-align: center;
  max-width: 300px; /* 设置最大宽度，可以根据需要调整 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出内容 */
  text-overflow: ellipsis; /* 显示省略号 */
  display: inline-block; /* 或者 block，取决于布局需求 */
}
.isActive {
  color: #131414;
}

.falseCollapse {
  margin-left: 8px;
}
.hideIcon {
  :deep(.el-sub-menu__title .el-icon) {
    display: none !important;
  }
}

:deep(.el-sub-menu__title) {
  height: 36px;
}

:deep(.el-menu-item) {
  // padding-left: 16px !important;
  word-wrap: break-word;
  word-break: break-all;
}
.menu_max_width {
  height: 76px;
}
:deep(.el-sub-menu .el-menu-item) {
  height: 36px !important;
  line-height: inherit !important;
  padding: 10px;
}
// .pl44 {
//   padding-left: 48px !important;
// } // 产品提出要显示出层级关系

.currency-items {
  margin-right: 24px;
}
.complex_btn {
  margin-right: 10px;
}
.yushen_btn {
  border-color: #095540;
  color: #095540;
  margin: 0 10px 0 0;
}
.currency_unit {
  margin-right: 24px;
  font-weight: bold;
}
// .ml28 {
//   margin-left: 8px;
// }
.isLine {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 2px;
    height: 30px;
    transform: translateY(-50%);
    background-color: #fff;
  }
}

:deep(.el-table .cell) {
  padding: 0px 2px !important;
}
a {
  text-decoration: none !important;
  color: inherit !important;
}
.unpaid-text {
  color: #f56c6c;
  font-weight: bold;
  background-color: #fef0f0;
  padding: 2px 6px;
  border-radius: 4px;
}
// 未打印状态 - 橙色
.unprinted-row {
  color: #fa8c16;
  font-weight: bold;
  background-color: #fff7e6;
  padding: 2px 6px;
  border-radius: 4px;
}

.ticket-flex-container {
  word-break: break-all;
  line-height: 1.3;
  white-space: normal;
}

// 功能按钮组样式
.function-buttons {
  display: flex;
  align-items: center;
  margin-right: 16px;
  padding-right: 16px;
  border-right: 1px solid #d4d7de; // 添加分隔线
}

.complex_btn {
  margin-right: 10px;
}

.yushen_btn {
  border-color: #095540;
  color: #095540;
  margin: 0 10px 0 0;
}

// 币种选择组样式
.currency-section {
  display: flex;
  align-items: center;
}

.currency-items {
  margin-right: 24px;
}

:deep(.el-menu--inline > a),
:deep(.el-menu--inline > span) {
  display: block;
}
</style>
